<div class="landscape">
  <div class='gc-contextual'>
    <div class="context-wrapper">
      <nav class="container wb-navcurr">
        <h3>{{'footer.cbsaTitle' | translate}}</h3>
        <ul class="list-unstyled colcount-sm-2 colcount-md-3">
          <li>
            <a href="{{'footer.contactUs_link' | translate}}" target="_blank">{{'footer.contactUs' | translate}}</a>
          </li>
          <li>
            <a href="{{'footer.publicationsForms_link' | translate}}" target="_blank">{{'footer.publicationsForms' | translate}}</a>
          </li>
          <li>
            <a href="{{'footer.cbsaGlossary_link' | translate}}" target="_blank">{{'footer.cbsaGlossary' | translate}}</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <div class="context-wrapper">
    <nav class="container wb-navcurr">
      <h3>{{'footer.governmentCanada' | translate}}</h3>
      <ul class="list-unstyled colcount-sm-2 colcount-md-3">
        <li><a href="{{'footer.allContacts_link' | translate}}" target="_blank">{{'footer.allContacts' | translate}}</a></li>
        <li><a href="{{'footer.departmentsAgencies_link' | translate}}" target="_blank">{{'footer.departmentsAgencies' | translate}}</a></li>
        <li><a href="{{'footer.aboutGovernment_link' | translate}}" target="_blank">{{'footer.aboutGovernment' | translate}}</a></li>
      </ul>

      <h4>
        <span class="wb-inv">Themes and topics</span>
      </h4>

      <ul class="list-unstyled colcount-sm-2 colcount-md-3">
        <li><a href="{{'footer.jobs_link' | translate}}" target="_blank">{{'footer.jobs' | translate}}</a></li>
        <li><a href="{{'footer.immigrationCitizenship_link' | translate}}" target="_blank">{{'footer.immigrationCitizenship' | translate}}</a></li>
        <li><a href="{{'footer.travelTourism_link' | translate}}" target="_blank">{{'footer.travelTourism' | translate}}</a></li>
        <li><a href="{{'footer.business_link' | translate}}" target="_blank">{{'footer.business' | translate}}</a></li>
        <li><a href="{{'footer.benefits_link' | translate}}" target="_blank">{{'footer.benefits' | translate}}</a></li>
        <li><a href="{{'footer.health_link' | translate}}" target="_blank">{{'footer.health' | translate}}</a></li>



        <li><a href="{{'footer.taxes_link' | translate}}" target="_blank">{{'footer.taxes' | translate}}</a></li>
        <li><a href="{{'footer.environmentNaturalResources_link' | translate}}" target="_blank">{{'footer.environmentNaturalResources' | translate}}</a></li>
        <li><a href="{{'footer.nationalSecurityDefence_link' | translate}}" target="_blank">{{'footer.nationalSecurityDefence' | translate}}</a></li>
        <li><a href="{{'footer.cultureHistorySport_link' | translate}}" target="_blank">{{'footer.cultureHistorySport' | translate}}</a></li>
        <li><a href="{{'footer.policingJusticeEmergencies_link' | translate}}" target="_blank">{{'footer.policingJusticeEmergencies' | translate}}</a></li>
        <li><a href="{{'footer.transportInfrastructure_link' | translate}}" target="_blank">{{'footer.transportInfrastructure' | translate}}</a></li>




        <li><a href="{{'footer.canadaTheWorld_link' | translate}}" target="_blank">{{'footer.canadaTheWorld' | translate}}</a></li>



        <li><a href="{{'footer.moneyFinance_link' | translate}}" target="_blank">{{'footer.moneyFinance' | translate}}</a></li>


        <li><a href="{{'footer.scienceInnovation_link' | translate}}" target="_blank">{{'footer.scienceInnovation' | translate}}</a></li>


        <li><a href="{{'footer.indigenousPeoples_link' | translate}}" target="_blank">{{'footer.indigenousPeoples' | translate}}</a></li>


        <li><a href="{{'footer.veteransMilitary_link' | translate}}" target="_blank">{{'footer.veteransMilitary' | translate}}</a></li>


        <li><a href="{{'footer.youth_link' | translate}}" target="_blank">{{'footer.youth' | translate}}</a></li>
      </ul>
    </nav>
  </div>
</div>


